{
  "seat": {
    "nav": "Workbench",
    "title": "Kinio Station workbench",
    "subtitle": "Read-only: data comes from the dev plane lease center and station reports. Use kst to run tools or lease a DUT.",
    "not_found": "Page not found",
    "plane_down": "Cannot reach the dev plane ({{code}}), so workbench data is unavailable. To check a station, open its local workbench page {{url}} on that machine.",
    "loading": "Loading…",
    "view_stations": "By station",
    "view_resources": "By resource",
    "col_station": "Station",
    "col_model": "Model",
    "col_version": "Tools version",
    "col_online": "Connection",
    "col_mode": "Mode",
    "col_resources": "Resources (busy / all)",
    "col_running": "Running",
    "col_leases": "Leases",
    "online": "Online",
    "offline": "Offline",
    "last_seen": "Last seen {{ago}} ago",
    "mode_seat": "Workbench mode",
    "mode_full": "Full",
    "prob_offline": "Offline",
    "prob_duplicate": "Duplicate resource id",
    "prob_tools_down": "Tools daemon not running",
    "running_item": "{{tool}} ({{caller}}, {{ago}})",
    "lease_item": "{{name}}: {{holder}} ({{purpose}}, until {{until}})",
    "col_dut": "DUT",
    "col_type": "Type",
    "col_state": "State",
    "col_holder": "Holder",
    "col_purpose": "Purpose",
    "col_expires": "Expires",
    "state_free": "Free",
    "state_busy": "Busy",
    "state_offline": "Offline",
    "dup_hint": "DUTs in red are reported by more than one station: the lease center will not lease them until one registration is changed.",
    "leases_err": "Lease center unavailable ({{code}}); showing the stations' lease summaries instead (may lag 30 s).",
    "empty": "—",
    "back": "← All stations",
    "detail_info": "Station info",
    "hostname": "Hostname",
    "lan": "LAN addresses",
    "modules": "Modules",
    "ui_home": "Local home screen",
    "detail_resources": "Resources",
    "detail_tools": "Tools (listed only, not run here)",
    "col_tool": "Tool",
    "col_tier": "Tier",
    "col_summary": "Description",
    "tools_err": "Could not load the tool list ({{code}})",
    "detail_runs": "Recent runs",
    "col_caller": "Caller",
    "col_started": "Started",
    "col_ended": "Ended",
    "show_output": "Show output",
    "hide_output": "Hide",
    "output_empty": "(no output)",
    "output_truncated": "(first 256 KB only)",
    "output_err": "Could not load the output ({{code}})",
    "runs_err": "Could not load recent runs ({{code}})",
    "screenshot": "Remote screenshot",
    "screenshot_busy": "Capturing…",
    "screenshot_err": "Screenshot failed ({{code}})",
    "screenshot_err_UI_NOT_RUNNING": "The station UI is not open (nvr-ui is not running), so there is nothing to capture.",
    "kst_hint": "To operate this station: kst show {{name}}",
    "station_missing": "This station is not among the stations you can see.",
    "run_running": "Running",
    "run_succeeded": "Succeeded",
    "run_failed": "Failed",
    "run_cancelled": "Cancelled",
    "run_timeout": "Timed out",
    "screenshot_err_SCREEN_TOO_LARGE": "The screenshot is too large (over 8 MB) and was not fetched."
  }
}
